<template>
  <div class="home">
    <v-carousel
      height="500"
      class="page-header hidden-sm-and-down"
      cycle
      hide-delimiters
    >
      <v-carousel-item v-for="(item, i) in carouselItems" :key="i">
        <v-img :src="item" height="500" max-height="500" />
      </v-carousel-item>
    </v-carousel>

    <div class="page-content">
      <div class="page-section">
        <h2>{{ $t("texts.notices") }}</h2>
        <v-slide-group class="pa-4" show-arrows="desktop">
          <v-slide-item v-for="notice in notices" :key="notice._id">
            <v-card class="ma-4" width="300" color="secondary">
              <v-img
                :src="getImage(notice.image)"
                lazy-src="@/assets/no-image.jpg"
                height="200px"
              ></v-img>
              <v-card-title class="accent--text">
                {{ notice.title }}
              </v-card-title>
              <v-card-subtitle class="accent--text">
                {{ formatDate(notice.actionDates.creation.timestamp) }}
              </v-card-subtitle>
              <v-card-actions>
                <v-btn
                  text
                  color="primary"
                  @click="openDialogWithDetails(notice)"
                  >{{ $t("texts.seeMore") }}</v-btn
                >
              </v-card-actions>
            </v-card>
          </v-slide-item>
        </v-slide-group>
      </div>
    </div>

    <div class="page-footer">
      <v-container>
        <v-row>
          <v-col cols="12" lg="6">
            <h3>{{ $t("texts.contactus") }}</h3>
            <p>
              {{ $t("texts.sendsuggestion") }}
              <br />
              {{ $t("texts.contactaspossible") }}
            </p>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  text
                  class="mt-2"
                  :href="'tel:' + $config.app.contacts.phoneNumber"
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-icon large class="mr-4">mdi-phone</v-icon>
                  {{ $config.app.contacts.phoneNumber }}
                </v-btn>
              </template>
              <span>{{ $t("texts.openMobileTooltip") }}</span>
            </v-tooltip>
            <br />
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  text
                  class="mt-4"
                  :href="'mailto:' + $config.app.contacts.email"
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-icon large class="mr-4">mdi-email</v-icon>
                  {{ $config.app.contacts.email }}
                </v-btn>
              </template>
              <span>{{ $t("texts.openEmailTooltip") }}</span>
            </v-tooltip>
          </v-col>
          <v-col cols="12" lg="6">
            <v-form @submit.prevent="contactUs" class="page-footer--form">
              <v-row>
                <v-col cols="12" sm="6">
                  <a-text-field
                    v-model="$v.name.$model"
                    :validator="$v.name"
                    :label="$t('texts.name')"
                  />
                </v-col>
                <v-col cols="12" sm="6">
                  <a-text-field
                    v-model="$v.email.$model"
                    :validator="$v.email"
                    type="email"
                    :label="$t('texts.email')"
                  />
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <a-text-field
                    v-model="$v.subject.$model"
                    :validator="$v.subject"
                    :label="$t('texts.subject')"
                  />
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <a-textarea
                    v-model="$v.message.$model"
                    :validator="$v.message"
                    :label="$t('texts.message')"
                    rows="3"
                  />
                </v-col>
              </v-row>
              <v-row class="mt-2">
                <v-col cols="12" align="end">
                  <v-btn color="primary" type="submit">{{
                    $t("texts.send")
                  }}</v-btn>
                </v-col>
              </v-row>
            </v-form>
          </v-col>
        </v-row>
      </v-container>
    </div>

    <!-- Details Notices -->
    <v-dialog v-model="detailsNoticesDialog" max-width="1000px">
      <v-card>
        <v-container class="pa-4">
          <div class="d-flex flex-column-reverse flex-sm-row mx-2 mb-4">
            <div>
              <h4>{{ $t("texts.notice") }} {{ this.selectedNoticeTitle }}</h4>
            </div>
            <div class="ml-auto">
              <v-btn icon color="accent" @click="closeDialogWithDetails">
                <v-icon x-large>mdi-close</v-icon>
              </v-btn>
            </div>
          </div>

          <v-row class="mx-1">
            <v-col cols="12">
              <p>
                <b> {{ $t("texts.published") }}</b
                >{{ this.selectedNoticeCreationDate }}
              </p>
            </v-col>
          </v-row>

          <v-row class="mx-1" v-if="this.selectedNoticeImage !== null">
            <v-col cols="12">
              <p>
                <v-img
                  v-if="this.selectedNoticeImage !== null"
                  :src="this.selectedNoticeImage"
                  :alt="this.errorImage"
                  aspect-ratio="2.5"
                  contain
                ></v-img>
              </p>
            </v-col>
          </v-row>
          <v-row class="mx-1 mb-1">
            <v-col cols="12">
              <p>
                <b> {{ $t("texts.description") }}: </b>
              </p>
              {{ this.selectedNoticeDescription }}
            </v-col>
          </v-row>
        </v-container>
      </v-card>
    </v-dialog>
    <!-- /Details Notices -->
  </div>
</template>

<style scoped lang="sass">
.page-content
    margin-top: $page-content-home-margin-top
@media (max-width: 959px)
  .page-content
    margin-top: 0

.page-footer
  background-color: #dadada
  border-top: 2px solid #8a8a8a
  min-height: 400px
  margin-bottom: $footer-height

  &--form
    padding: 10px 25px
    background-color: var(--v-secondary-base)
    border-width: 2px
    border-color: #8a8a8a
    border-style: solid
    border-radius: 15px
</style>

<script>
// @ is an alias to /src
import AppError from "@/utils/AppError.js";
import ATextField from "@/components/fields/ATextField.vue";
import ATextarea from "@/components/fields/ATextarea.vue";

import { parseISO } from "date-fns";
import { validationMixin } from "vuelidate";
import { required, email } from "vuelidate/lib/validators";

export default {
  name: "Home",

  components: {
    ATextField,
    ATextarea
  },
  beforeMount: function() {
    this.loadBanners();
  },
  mounted: function() {
    this.getNotices();
  },

  mixins: [validationMixin],

  validations: {
    name: { required },
    email: { required, email },
    subject: { required },
    message: { required }
  },

  data() {
    return {
      //Modals
      detailsNoticesDialog: false,
      //#Modals
      errorImage: "Image",
      notices: [],
      selectedNoticeTitle: "",
      selectedNoticeDescription: "",
      selectedNoticeCreationDate: "",
      selectedNoticeImage: "",
      carouselItems: [],

      // Form data
      name: null,
      email: null,
      subject: null,
      message: null
    };
  },

  methods: {
    /**
     * Get the notice details
     *  @param {notice} item - the notice.
     * @public
     */
    openDialogWithDetails(item) {
      this.detailsNoticesDialog = true;
      let selectedNotice = this.notices[this.notices.indexOf(item)];
      this.selectedNoticeTitle = selectedNotice.title;
      this.selectedNoticeDescription = selectedNotice.description;
      this.selectedNoticeCreationDate = this.formatDate(
        selectedNotice.actionDates.creation.timestamp
      );
      if (selectedNotice.image != null) {
        this.selectedNoticeImage =
          process.env.VUE_APP_API_BASE_URI + "/" + selectedNotice.image;
      } else {
        this.selectedNoticeImage = null;
      }
    },
    loadBanners() {
      var location = process.env.VUE_APP_API_BASE_URI + "/banners/";
      // Load  data
      const loadFormData = this.$api({
        url: this.$config.api.route.banners + "?filter=true",
        method: "GET"
      }).then(resp => {
        var banners = resp.data[0].banners;
        this.carouselItems = banners.map(item => location + item.image);
      });
      // Async handle loads
      this.$store.dispatch("Util/startLoading");
      Promise.all([loadFormData])
        .catch(() => {
          AppError.handle(new AppError("LOAD_DATA_UNKNOWN"));
        })
        .finally(() => {
          this.$store.dispatch("Util/stopLoading");
        });
    },
    /**
     * Get the image
     *  @param {string} image - the image.
     * @public
     */
    getImage(image) {
      if (!image) return;
      return process.env.VUE_APP_API_BASE_URI + "/" + image;
    },
    /**
     * Close the details dialog
     * @public
     */
    closeDialogWithDetails() {
      this.detailsNoticesDialog = false;
      this.selectedNoticeTitle = "";
      this.selectedNoticeDescription = "";
      this.selectedNoticeCreationDate = "";
      this.selectedNoticeImage = "";
    },

    /**
     * Format the date
     * @param {date} value - The date to format.
     * @public
     */
    formatDate(value) {
      return value ? this.$d(parseISO(value), "short") : "";
    },

    /**
     * Get the notices
     * @public
     */
    getNotices() {
      this.$store.dispatch("Util/startLoading");
      this.$api({
        url: this.$config.api.route.notices,
        method: "GET"
      })
        .then(resp => {
          this.notices = resp.data;
        })
        .catch(err => {
          AppError.handle(err);
        })
        .finally(() => {
          this.$store.dispatch("Util/stopLoading");
        });
    },

    /**
     * Contact us form.
     * @public
     */
    contactUs() {
      this.$v.$touch();
      if (this.$v.$invalid) return;

      this.$store.dispatch("Util/startLoading");
      this.$api({
        url: this.$config.api.route.contactUs,
        data: {
          name: this.name,
          email: this.email,
          subject: this.subject,
          message: this.message
        },
        method: "POST"
      })
        .then(() => {
          this.$store.dispatch(
            "Alert/showSuccess",
            this.$t("texts.sendcontactus")
          );

          // Reset fields and validations
          this.name = null;
          this.email = null;
          this.subject = null;
          this.message = null;
          this.$v.$reset();
        })
        .catch(err => {
          AppError.handle(err);
        })
        .finally(() => {
          this.$store.dispatch("Util/stopLoading");
        });
    }
  }
};
</script>
